export default "__VITE_ASSET__ccd5770f__"